import icon1 from '../assets/criteria/сriteria-icon-1.svg';
import icon2 from '../assets/criteria/сriteria-icon-2.svg';
import icon3 from '../assets/criteria/сriteria-icon-3.svg';

/* секция критерии  */
export function Criteria() {
  return (
    <div className="web-page-new" data-model-id="877:8470">
      <div className="element">
        <div className="text-wrapper-6">Критерии оценки</div>
        <div className="frame-8">
          <div className="frame-9">
            <img
              className="interface-essential"
              alt="Interface essential"
              src={icon1}
            />
            <div className="icon-wrapper">
              <div className="icon">
                <div className="text-wrapper-7">Технологическая часть</div>
                <p className="MVP">
                  качество и реалистичность MVP;
                  <br />
                  продуманность архитектуры.
                </p>
              </div>
            </div>
          </div>
          <div className="frame-10">
            <img
              className="icon-2"
              alt="Icon"
              src={icon2}
            />
            <div className="frame-11">
              <div className="text-wrapper-7">Продуктовая часть</div>
              <p className="text-wrapper-8">
                понятность сценария использования;
                <br />
                ценность для ПФК ЦСКА;
                <br />
                реалистичность внедрения
              </p>
            </div>
          </div>
          <div className="frame-10">
            <img
              className="interface-essential"
              alt="Interface essential"
              src={icon3}
            />
            <div className="frame-11">
              <div className="text-wrapper-7">Креативность</div>
              <p className="text-wrapper-8">
                визуальная выразительность;
                оригинальность идеи
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}